import {Action} from "@dp-instant/core";
import {log} from "@dp-instant/utils";
import {inject, injectable} from "inversify";
import {TypesGame} from "@game/TypesGame";
import {GameModel} from "@game/coregame/model/GameModel";
import {UIEvents} from "@dp-instant/ui";
import {PopupType} from "@game/ui/PopupType";
import {TypesSocial} from "@dp-instant/interfaces";
import {ISocial} from "@dp-instant/social";
import {BattleResultsPopupProps} from "@game/ui/popups/battle-results/BattleResultsPopup";
import {apiClient} from "@game/api/ApiClient";

@injectable()
export class BattleResultsPopupAction extends Action<boolean> {
    @inject(TypesGame.model)
    private readonly model: GameModel;

    @inject(TypesSocial.model)
    private readonly social: ISocial;

    async execute(win = true): Promise<any> {
        const success = await new Promise<boolean>(onContinue => {
            const props: BattleResultsPopupProps = {win, onContinue};
            this.dispatch(UIEvents.POPUP, {
                id: PopupType.BATTLE_RESULTS,
                props
            });
        });
        log.debug("BattleResultsPopupAction shared", success);

        // Show referral gift popup after first battle (if user came via referral)
        if (__SOCIAL__ === "tg" && (window as any).__tgReferralGiftPending) {
            (window as any).__tgReferralGiftPending = false;
            await new Promise<void>(resolve => {
                this.dispatch(UIEvents.POPUP, {
                    id: PopupType.REFERRAL_GIFT,
                    props: { onConfirm: () => resolve() }
                });
            });
            apiClient.claimReferralGift().catch(() => {});
        }
    }
}
